import { useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { PastOperationAndDriverIdEntity } from 'src/entities/PastOperationAndDriverId.entity';

const requestPathV5 = (startOn: string) => `/api/v5/plannings/past_order_operations/${startOn}`;

const getRecordsV5: (startOn: string) => () => Promise<PastOperationAndDriverIdEntity[]> = (startOn) => async () => {
  const response: AxiosResponse<PastOperationAndDriverIdEntity[]> = await axios.get(requestPathV5(startOn));

  return response.data;
};

export const usePastOperationsQueryV5 = (startOn: string) => useQuery(
    ['usePastOperationsQueryV5', { startOn }],
    getRecordsV5(startOn),
    {
      staleTime: Infinity,
      enabled: !!startOn
    }
  );
